import p from "react";
function o(t) {
  "@babel/helpers - typeof";
  return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, o(t);
}
function b(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function s(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, a(n.key), n);
  }
}
function _(t, e, r) {
  return e && s(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function m(t, e, r) {
  return e = i(e), v(t, f() ? Reflect.construct(e, r || [], i(t).constructor) : e.apply(t, r));
}
function v(t, e) {
  if (e && (o(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return O(t);
}
function O(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function f() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (f = function() {
    return !!t;
  })();
}
function i(t) {
  return i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, i(t);
}
function P(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && u(t, e);
}
function u(t, e) {
  return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, y) {
    return n.__proto__ = y, n;
  }, u(t, e);
}
function c(t, e, r) {
  return e = a(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function a(t) {
  var e = d(t, "string");
  return o(e) == "symbol" ? e : e + "";
}
function d(t, e) {
  if (o(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var l = /* @__PURE__ */ function(t) {
  function e() {
    return b(this, e), m(this, e, arguments);
  }
  return P(e, t), _(e, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
}(p.Component);
c(l, "displayName", "ZAxis");
c(l, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
export {
  l as ZAxis
};
